/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiDocument } from '../../asyncapi/models/AaiDocument';
import { AaiMessageTrait } from '../../asyncapi/models/AaiMessageTrait';
import { AaiMessageTraitDefinition } from '../../asyncapi/models/AaiMessageTraitDefinition';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { VisitorUtil } from '../../core/util/VisitorUtil';
import { TraverserDirection } from '../../core/visitors/TraverserDirection';
import { Node } from '../../core/models/Node';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';

/**
 * A command used to rename a message trait definition item in an AsyncAPI document.
 * @author laurent.broudoux@gmail.com
 * @param {string} oldName
 * @param {string} newName
 * @class
 * @extends AbstractCommand
 */
export class RenameMessageTraitDefinitionCommand extends AbstractCommand {
    public _oldName : string;

    public _newName : string;

    public _references : Array<NodePath>;

    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            (() => {
                this._oldName = oldName;
                this._newName = newName;
            })();
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
            if(this._oldName===undefined) this._oldName = null;
            if(this._newName===undefined) this._newName = null;
            if(this._references===undefined) this._references = null;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameMessageTraitDefinitionCommand] Executing.");
        this._references = <any>([]);
        let doc : AaiDocument = <AaiDocument>document;
        if(this.renameMessageTraitDefinition(doc, this._oldName, this._newName)) {
            let oldRef : string = this.nameToReference(this._oldName);
            let newRef : string = this.nameToReference(this._newName);
            let finder : RenameMessageTraitDefinitionCommand.MessageTraitRefFinder = new RenameMessageTraitDefinitionCommand.MessageTraitRefFinder(oldRef);
            let traits : Array<AaiMessageTrait> = finder.findIn(document);
            for(let index152=0; index152 < traits.length; index152++) {
                let trait = traits[index152];
                {
                    /* add */(this._references.push(Library.createNodePath(trait))>0);
                    trait.$ref = newRef;
                }
            }
        }
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameMessageTraitDefinitionCommand] Reverting.");
        if(this.renameMessageTraitDefinition(<AaiDocument>document, this._newName, this._oldName)) {
            let oldRef : string = this.nameToReference(this._oldName);
            if(ModelUtils.isDefined(this._references)) {
                this._references.forEach(((oldRef) => {
                    return (ref) => {
                        let msgTrait : AaiMessageTrait = <AaiMessageTrait>ref.resolve(document);
                        msgTrait.$ref = oldRef;
                    }
                })(oldRef));
            }
        }
    }

    nameToReference(name : string) : string {
        return "#/components/messageTraits/" + name;
    }

    renameMessageTraitDefinition(document : AaiDocument, fromName : string, toName : string) : boolean {
        let doc20 : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(doc20.components) || this.isNullOrUndefined(doc20.components.messageTraits)) {
            return false;
        }
        if(ModelUtils.isDefined(doc20.components.getMessageTraitDefinition(toName))) {
            return false;
        }
        let traitDef : AaiMessageTraitDefinition = doc20.components.removeMessageTraitDefinition(fromName);
        traitDef.rename(toName);
        doc20.components.addMessageTraitDefinition(toName, traitDef);
        return true;
    }
}
RenameMessageTraitDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameMessageTraitDefinitionCommand";
RenameMessageTraitDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];



export namespace RenameMessageTraitDefinitionCommand {

    export class MessageTraitRefFinder extends CombinedVisitorAdapter {
        reference : string;

        traits : Array<AaiMessageTrait> = <any>([]);

        public constructor(ref : string) {
            super();
            if(this.reference===undefined) this.reference = null;
            this.reference = ref;
        }

        public findIn(document : Document) : Array<AaiMessageTrait> {
            VisitorUtil.visitTree(document, this, TraverserDirection.down);
            return this.traits;
        }

        /**
         * 
         * @param {AaiMessageTrait} node
         */
        public visitMessageTrait(node : AaiMessageTrait) {
            if(this.accept(node)) {
                /* add */(this.traits.push(node)>0);
            }
        }

        accept(trait : AaiMessageTrait) : boolean {
            return ModelUtils.isDefined(trait.$ref) && NodeCompat.equals(trait.$ref, this.reference);
        }
    }
    MessageTraitRefFinder["__class"] = "io.apicurio.datamodels.cmd.commands.RenameMessageTraitDefinitionCommand.MessageTraitRefFinder";
    MessageTraitRefFinder["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];


}



